
import { IFormViewForm } from 'components/FormView';

const FreightChargeDetails: IFormViewForm = {
    id: 'FreightChargeDetails',
    layout: {
        rows: 1,
        columns: 2
    },
    fields: [
        {
            id: 0,
            position: {
                row: 1,
                col: 1
            },
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                label: '',
                fullWidth: true
            },
            children: [
                {
                    id: '0',
                    type: 'EXTENDED_DISPLAY_FIELD',
                    props: {
                        label: 'Freight',
                        name: 'FreightCharge',
                        placeholder: '',
                        size: 'medium',
                        decimalSeparator: true,
                        type: 'number',
                        alignment: 'right',
                        decimalPlaces: 2
                    }
                },
                {
                    id: '1',
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    props: {
                        label: 'Use separate freight supplier',
                        name: 'UseSeperateSupplier'
                    }
                },
                {
                    id: '2',
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Supplier',
                        name: 'SupplierId',
                        placeholder: '',
                        size: 'small',
                        required: true,
                        lookupName: 'Supplier',
                    }
                },
                {
                    id: '3',
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'Reference',
                        name: 'Reference',
                        placeholder: '',
                        size: 'medium',
                    }
                },
                {
                    id: 4,
                    type: 'TEXT_AREA',
                    props: {
                        label: 'Comment',
                        name: 'Comment',
                        size: 'small',
                        style: {
                            'height': '150px',
                            '& label': {
                                paddingTop: 0,
                            }
                        },
                    }
                },
            ]
        },
        {
            id: 1,
            position: {
                row: 1,
                col: 2
            },
            type: 'PAPER_CONTAINER',
            visible: true,
            props: {
                fullWidth: true
            },
            hideInV2: true,
            children: [
                {
                    id: 0,
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'Cubic',
                        name: 'Cubic',
                        size: 'medium',
                        alignment: 'right',
                    }
                },
                {
                    id: 1,
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'Weight',
                        name: 'Weight',
                        size: 'medium',
                        alignment: 'right',
                    }
                }
            ]
        },
    ]
};

export default FreightChargeDetails;
